export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://syi.scieverinc.com/api/v1-dev";
export const IDENTITY_SERVER_URL =
  process.env.REACT_APP_IDENTITY_SERVER || "https://syi.sis.scieverinc.com/";
export const CLIENT_ID =
  process.env.REACT_APP_CLIENT_ID || "26fe06a1-a9a9-4071-a474-cab36a84a354";
export const LOCATION_SERVER_URL =
  process.env.REACT_APP_LOCATION_SERVER ||
  "https://syi.scieverinc.com/api/sls/v1-dev";
